var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BASE_LIST_STORE_INITIAL_VALUES } from 'common/store';
export var INITIAL_STATE = __assign(__assign({}, BASE_LIST_STORE_INITIAL_VALUES), { content: [], pageSize: 20, chatId: null, fullNameFilter: '' });
